import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  IActivo,
  IFilter,
  IQueryParam,
  IUpdateActivo,
  IUsuario,
} from 'modelos/src';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { ActivosService } from '../../../../auxiliares/servicios/http/activos.service';

import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';

@Component({
  imports: [AuxiliaresModule],
  selector: 'app-asignar-vehiculo-chofer',
  templateUrl: './asignar-vehiculo-chofer.component.html',
  styleUrl: './asignar-vehiculo-chofer.component.scss',
  standalone: true,
})
export class AsignarVehiculoChoferComponent implements OnInit {
  data = inject<{
    usuario: IUsuario;
    tipo: string;
  }>(MAT_DIALOG_DATA);
  private lista2 = inject(Lista2Service);
  private helper = inject(HelperService);
  private activosService = inject(ActivosService);
  private dialogRef =
    inject<MatDialogRef<AsignarVehiculoChoferComponent>>(MatDialogRef);

  public vehiculoInicialID: string = '';
  public vehiculos: (IActivo & { label: string })[] = [];
  public vehiculos$?: Subscription;
  public totalCount = 0;
  public form?: FormGroup;
  public vehiculo: IActivo = {};

  public filter: IFilter<IActivo> = {};

  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    sort: 'nombre',
    page: 0,
    includeChildren: false,
    childrenLevel: 0,
  };

  public filterVehiculos: IFilter<IActivo> = {};
  public queryVehiculos: IQueryParam = {
    filter: JSON.stringify(this.filterVehiculos),
    page: 0,
    includeChildren: false,
    childrenLevel: 0,
  };
  public usuario: IUsuario = {};
  public vehiculoActual() {
    const vehiculo = this.vehiculos.find(
      (v) => v.vehiculo?.idChofer === this.usuario?._id,
    );
    if (vehiculo) this.vehiculo = vehiculo;
  }

  public close(id?: string): void {
    this.dialogRef.close(id);
  }

  public getData(): IUpdateActivo {
    const data: IUpdateActivo = this.form?.value;
    return data;
  }

  public async asignarVehiculo() {
    try {
      // Verificar que el vehículo esté seleccionado y tenga la estructura necesaria
      if (!this.vehiculo || !this.vehiculo._id) {
        this.helper.notifError('Seleccioná un vehículo');
        return;
      }

      // Asegurar que el objeto vehiculo existe, si no, crearlo
      const v = this.vehiculo.vehiculo || {};
      v.idChofer = this.data?.usuario._id;

      const res = await this.activosService.asignarChofer(
        this.vehiculo._id,
        this.data?.usuario._id,
      );
      this.helper.notifSuccess('Conductor Asignado');
      this.close(this.vehiculo._id);
    } catch (error) {
      console.error(error);
      this.helper.notifError('Error al Asignar');
    }
  }

  // Etiqueta visible/buscable del vehículo: "identificación · patente — marca modelo".
  private armarLabelVehiculo(a: IActivo): string {
    const v = a.vehiculo || {};
    const base = [a.identificacion, v.patente].filter(Boolean).join(' · ');
    const mm = [v.marca, v.modelo].filter(Boolean).join(' ');
    return mm ? `${base || mm} — ${mm}` : base || a._id || '';
  }

  public async listarVehiculos(): Promise<void> {
    // Vehículos del propio cliente del conductor. includeChildren:true para que el
    // scope alcance al cliente (si es hijo) y se filtra por su idCliente exacto.
    const idCliente = this.data?.usuario?.idCliente;
    this.queryVehiculos.filter = JSON.stringify(idCliente ? { idCliente } : {});
    this.queryVehiculos.includeChildren = true;
    this.queryVehiculos.sort = 'identificacion';

    const obs =
      this.data.tipo === 'Colectivos'
        ? this.lista2.colectivos(this.queryVehiculos, 30)
        : this.lista2.vehiculos(this.queryVehiculos, 30);

    this.vehiculos$?.unsubscribe();
    this.vehiculos$ = obs.subscribe((data) => {
      this.vehiculos = (data.datos || [])
        .filter((v) => !idCliente || String(v.idCliente) === String(idCliente))
        .map((v) => ({ ...v, label: this.armarLabelVehiculo(v) }))
        .sort((a, b) =>
          a.label.localeCompare(b.label, 'es', { sensitivity: 'base' }),
        );
      this.vehiculoActual();
    });
  }

  async ngOnInit() {
    this.usuario = this.data?.usuario;
    await this.listarVehiculos();
  }

  async ngOnDestoy() {
    this.vehiculos$.unsubscribe();
  }
}
